@if (hdKeynoteVisible()) {
  <div
    class="simple-keynote-card"
    [class.is-personality]="side() === 'personality'"
    data-test-id="simple-planet-keynote-card"
    role="tooltip"
    [id]="hdKeynoteId"
  >{{ hdKeynote() }}</div>
}

<div class="simple-planet-row" [class.is-personality]="side() === 'personality'" [class.is-design]="side() === 'design'">
  <span class="simple-planet-glyph">{{ displayConfig().astronomiconChar }}</span>
  <span class="simple-planet-gate-line">
    <span class="gate">{{ activation().gate }}</span><span class="dot">.</span><span class="line">{{ activation().line }}</span>
  </span>
  <span class="simple-planet-arrows">
    @if (showExaltationArrow()) {
      <span class="arrow exaltation">▲</span>
    }
    @if (showDetrimentArrow()) {
      <span class="arrow detriment">▼</span>
    }
  </span>
</div>
